<style>
#terminalCardModal .v--modal-box.v--modal {
  min-height: 360px !important;
  min-width: 550px !important;
}
#terminalCardModal .values__list {
  display: flex;
}
#terminalCardModal .values__list,
.list__container {
  width: 100%;
}
#start .v-subheader {
  padding-left: 0;
  color: #2a579a;
  font-weight: 700;
}
#start .list__container--el {
  display: flex;
  justify-content: space-between;
}
#start .modal__container {
  padding-bottom: 0px;
}
.list__container--el > span {
  margin-left: 10px;
}
#timeline {
  max-width: 100%;
}
.btn__subheader {
  opacity: 0.4;
  line-height: 40px;
  transition: all 0.2s;
}
.btn__subheader:hover {
  opacity: 1;
}
.first-subheader {
  height: 16px;
}
#terminalCardModal .list__container--edit {
  display: flex;
  align-items: center;
}
#terminalCardModal .card__edit--span {
  margin-bottom: 5px;
}
#terminalCardModal .card__edit--input {
  text-align: right;
  border-bottom: 1px solid lightgray;
}
#terminalCardModal .v-tabs__div:not(:last-child) {
  padding-right: 5px;
}
#terminalCardModal .v-tabs__div {
  background-image: linear-gradient(
      to bottom,
      rgba(42, 87, 154, 1) 0%,
      rgba(42, 87, 154, 1) 100%
    ),
    linear-gradient(
      to bottom,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 1) 100%
    );
  background-clip: content-box, padding-box;
}
#terminalCardModal .v-subheader {
  font-size: 14px !important;
  color: #000 !important;
  font-weight: 600 !important;
}
</style>

<template>
  <Modal
    modalName="terminalCardModal"
    :title="`KARTA PRZYŁĄCZA O ID ${selectedRow.id}`"
    :buttons="[]"
    :editing="editing"
    @editingStart="startEditing()"
    @editingSave="saveEditing()"
    @editingCancel="cancelEditing()"
    @opened="updateList()"
    :module="module"
    @closed="closed"
  >
    <v-tabs
      color="#2a579a"
      dark
      centered
      grow
      active-class="tab--active"
      :hide-slider="true"
      height="35"
    >
      <v-tab>ATRYBUTY</v-tab>
      <v-tab-item>
        <v-card flat id="attr__wrapper">
          <v-layout row wrap>
            <v-flex xs12>
              <v-subheader>DANE TECHNICZNE</v-subheader>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs5>
              <v-text-field
                v-model="terminalData.status"
                :readonly="!editing"
                label="Status"
              ></v-text-field>
            </v-flex>
            <v-spacer />
            <v-flex xs5>
              <v-text-field
                v-model="terminalData.net_kind"
                :readonly="!editing"
                label="Rodzaj sieci"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs5>
              <v-text-field
                v-model="terminalData.material"
                :readonly="!editing"
                label="Materiał"
              ></v-text-field>
            </v-flex>
            <v-spacer />
            <v-flex xs5>
              <v-text-field
                v-model="terminalData.calc_length"
                :readonly="!editing"
                label="Długość obliczeniowa"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs5>
              <v-text-field
                v-model="terminalData.length"
                :readonly="!editing"
                label="Długość"
              ></v-text-field>
            </v-flex>
            <v-spacer />
            <v-flex xs5>
              <v-text-field
                v-model="terminalData.diameter"
                :readonly="!editing"
                label="Średnica"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs5>
              <v-text-field
                v-model="terminalData.inventory"
                :readonly="!editing"
                label="Ewidencja"
              ></v-text-field>
            </v-flex>
            <v-spacer />
            <v-flex xs5>
              <v-text-field
                v-model="terminalData.parent_pipe"
                :readonly="!editing"
                label="Powiązany przewód"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs5>
              <v-text-field
                v-model="terminalData.producer"
                :readonly="!editing"
                label="Producent"
              ></v-text-field>
            </v-flex>
            <v-spacer />
            <v-flex xs5>
              <v-text-field
                v-model="terminalData.source"
                :readonly="!editing"
                label="Źródło"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs5>
              <v-text-field
                v-model="terminalData.thickness"
                :readonly="!editing"
                label="Grubość ścianki"
              ></v-text-field>
            </v-flex>
            <v-spacer />
            <v-flex xs5>
              <v-text-field
                v-model="terminalData.acquisition"
                :readonly="!editing"
                label="Sposób pozyskiwania"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs5>
              <v-text-field
                v-model="terminalData.year"
                :readonly="!editing"
                label="Rok budowy"
              ></v-text-field>
            </v-flex>
            <v-spacer />
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <v-subheader>DANE ADRESOWE</v-subheader>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs5>
              <v-text-field
                v-model="terminalData.address_place"
                :readonly="!editing"
                label="Miejscowość"
              ></v-text-field>
            </v-flex>
            <v-spacer />
            <v-flex xs5>
              <v-text-field
                v-model="terminalData.address_community"
                :readonly="!editing"
                label="Gmina"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs5>
              <v-text-field
                v-model="terminalData.address_street"
                :readonly="!editing"
                label="Ulica"
              ></v-text-field>
            </v-flex>
            <v-spacer />
            <v-flex xs5>
              <v-text-field
                v-model="terminalData.address_order"
                :readonly="!editing"
                label="Numer porządkowy"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs5>
              <v-text-field
                v-model="terminalData.address_local"
                :readonly="!editing"
                label="Numer lokalu"
              ></v-text-field>
            </v-flex>
            <v-spacer />
            <v-flex xs5>
              <v-text-field
                v-model="terminalData.address_plot"
                :readonly="!editing"
                label="Numer działki"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <v-subheader>DANE WŁAŚCICIELA PRZYŁĄCZA</v-subheader>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs5>
              <v-text-field
                v-model="terminalData.owner_name"
                :readonly="!editing"
                label="Imię i nazwisko właściciela"
              ></v-text-field>
            </v-flex>
            <v-spacer />
            <v-flex xs5>
              <v-text-field
                v-model="terminalData.owner_place"
                :readonly="!editing"
                label="Miejscowość"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs5>
              <v-text-field
                v-model="terminalData.owner_zipcode"
                :readonly="!editing"
                label="Kod pocztowy"
              ></v-text-field>
            </v-flex>
            <v-spacer />
            <v-flex xs5>
              <v-text-field
                v-model="terminalData.owner_street"
                :readonly="!editing"
                label="Ulica"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs5>
              <v-text-field
                v-model="terminalData.owner_order_no"
                :readonly="!editing"
                label="Numer porządkowy"
              ></v-text-field>
            </v-flex>
            <v-spacer />
            <v-flex xs5>
              <v-text-field
                v-model="terminalData.owner_local_no"
                :readonly="!editing"
                label="Numer lokalu"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs5>
              <v-text-field
                v-model="terminalData.owner_phone"
                :readonly="!editing"
                label="Numer telefonu"
              ></v-text-field>
            </v-flex>
            <v-spacer />
            <v-flex xs5>
              <v-text-field
                v-model="terminalData.owner_email"
                :readonly="!editing"
                label="Adres email"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card>
      </v-tab-item>

      <!-- No events during adding insepction - that's why (0) -->
      <v-tab v-if="featureEvents != undefined"
        >ZDARZENIA ({{ featureEvents.events_count }})</v-tab
      >
      <v-tab v-else>ZDARZENIA (0)</v-tab>
      <v-tab-item>
        <v-card flat>
          <Events
            style="margin-top: 15px"
            :featureEvents="featureEvents"
            :objectType="objectType"
            :id="selectedRow.id"
          />
        </v-card>
      </v-tab-item>

      <v-tab v-if="attachmentsArr.hasOwnProperty('data')"
        >ZAŁĄCZNIKI ({{ attachmentsArr.data.length }})</v-tab
      >
      <v-tab-item>
        <v-layout row>
          <v-flex
            xs12
            v-if="
              $can('read', 'terminals_attachments') ||
                $can('edit', 'terminals_attachments')
            "
          >
            <v-subheader class="font--primary"
              >Powiązane załączniki</v-subheader
            >
            <div v-if="ifAttachments.hasOwnProperty('data')">
              <li
                class="list__container--el"
                v-for="(index, key) in attachmentsArr.data"
                :key="key"
              >
                <span>{{ index.id }} - {{ index.filename }}</span>
                <span>
                  <v-icon
                    @click="downloadAttachment(index.id, index.filename)"
                    small
                    title="Pobierz załącznik"
                    v-if="
                      $can('read', 'terminals_attachments') ||
                        $can('edit', 'terminals_attachments')
                    "
                    >cloud_download</v-icon
                  >
                  <v-icon
                    @click="deleteAttachment(index.id)"
                    small
                    title="Usuń załącznik"
                    v-if="$can('edit', 'terminals_attachments')"
                    >delete</v-icon
                  >
                </span>
              </li>
            </div>
            <div v-else>
              <p class="font--primary">Brak powiązanych załączników</p>
            </div>
            <AddAttachment
              v-if="selectedRow.hasOwnProperty('id')"
              v-show="editing"
              ref="childComponent"
              @attachmentAdded="updateList()"
              @attachmentDeleted="updateList()"
              @confDialogOpened="triggerDialogAttach"
              :id_="selectedRow.id"
              :objectType="objectType"
              :objectTable="objectTable"
              :auto="true"
              :module="module"
            />
          </v-flex>
        </v-layout>
        <v-layout row wrap v-show="editing">
          <v-subheader class="font--primary"
            >ZAŁĄCZNIKI Z BAZY DANYCH</v-subheader
          >
        </v-layout>
        <v-layout row wrap style="height: 90%" v-show="editing">
          <v-flex xs12>
            <DatabaseAttachments
              :objectIdCard="terminalData.id"
              :objectTableCard="objectTable"
              :objectTypeCard="objectType"
              @attachmentAdded="updateList"
            />
          </v-flex>
        </v-layout>
      </v-tab-item>
    </v-tabs>
  </Modal>
</template>

<script>
import AddAttachment from "../../../../shared/AddAttachment";
import DatabaseAttachments from "../../../table/attachments/DatabaseAttachments";
import Events from "../../../../shared/Events";
import Modal from "../../../../shared/Modal";

export default {
  components: {
    AddAttachment,
    DatabaseAttachments,
    Events,
    Modal
  },
  data: () => ({
    attachmentsArr: [],
    editing: false,
    module: "terminals",
    objectTable: "terminals",
    objectType: "layers",
    oid: undefined,
    selectedRow: {},
    terminalDataCopy: {},
    terminalData: {}
  }),
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    featureEvents() {
      return this.$store.getters.getFeatureEvents;
    },
    ifAttachments() {
      return this.$store.getters.getObjectAttachments;
    },
    getTerminalData() {
      if (this.$store.getters.getTerminalData) {
        return this.$store.getters.getTerminalData.values_;
      }
    },
    terminalsProperties() {
      return this.$store.getters.getLayers.find(
        layer => layer.full_type === "terminals"
      );
    }
  },
  methods: {
    cancelEditing() {
      this.editing = false;
      this.$store.commit("setTerminalData", this.terminalDataCopy);
      // this.terminalData = Object.assign({}, this.terminalDataCopy);
    },
    closed() {
      this.$store.commit("setFeatureEvents", undefined);
      this.$store.commit("setTerminalData", undefined);
    },
    deleteAttachment(attachmentId) {
      this.$refs.childComponent.deleteAttachment(attachmentId);
    },
    downloadAttachment(attachmentId, attachmentName) {
      this.$refs.childComponent.downloadAttachment(
        attachmentId,
        attachmentName
      );
    },
    loadData(data) {
      this.selectedRow = data;
      let payload = {
        object_id: data.id,
        object_type: "layers",
        events_count: true,
        objet_table: "terminals",
        limit: 5
      };

      this.$store.commit("setFeatureEvents", {});
      this.$store.dispatch("getFeatureEvents", payload).then(() => {
        this.$root.$emit("setAllFeatures");
        this.$root.$emit("loadEventsOnPage");
      });
      this.terminalData = this.getTerminalData;
    },
    saveEditing() {
      delete this.terminalData.geometry;
      let payload = {
        table: this.objectTable,
        body: {
          properties: this.terminalData,
          ids: [this.terminalData.id]
        }
      };
      this.$store.dispatch("editFeature", payload).then(r => {
        if (r) {
          this.$root.$emit("edited_terminal");
          this.editing = false;
        } else {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Podczas edytowania danych przyłącza wystąpił błąd"
          );
        }
      });
    },
    show(title) {
      if (this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    startEditing() {
      this.editing = true;
      this.terminalDataCopy = Object.assign({}, this.terminalData);
    },
    triggerDialogAttach(val) {
      this.$emit("confDialogOpened", val);
    },
    updateList() {
      if (this.terminalData) {
        let payload = {
          object_type: this.objectType,
          layer: this.objectTable,
          oid: this.selectedRow.id
        };
        this.$store
          .dispatch("getAttachmentsForObject", payload)
          .then(success => {
            if (success) {
              this.attachmentsArr = this.$store.getters.getObjectAttachments;
            }
          });
      }
    }
  },
  mounted() {
    this.$root.$on("deletedAttachmentGlobal", this.updateList);
    this.$root.$on("loadTerminalCard", this.loadData);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/start/modals/terminals/TerminalCard.vue